// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__m3RBf","subtitle":"subtitle__PHG3y","actions":"actions__TDG18","img-link":"img-link__UMiPT","imgLink":"img-link__UMiPT"};